import type { PublicTransfer } from '../types'
import { formatFileSize } from '../crypto'
import { FileIcon } from './FileIcon'

interface DownloadProgressProps {
  transfer: PublicTransfer
  progress: number
}

export function DownloadProgress({ transfer, progress }: DownloadProgressProps) {
  const file = transfer.files[0]
  const downloadedBytes = Math.round(transfer.total_size * progress)
  const percentage = Math.round(progress * 100)

  return (
    <div>
      {/* File info */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 'var(--space-md)',
        marginBottom: 'var(--space-lg)',
      }}>
        <FileIcon filename={file?.name || ''} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ 
            fontWeight: 500,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
            {file?.name || 'Encrypted file'}
          </div>
        </div>
      </div>

      {/* Progress section */}
      <div style={{ textAlign: 'center', marginBottom: 'var(--space-lg)' }}>
        <div style={{
          fontSize: '42px',
          fontWeight: 600,
          color: 'var(--accent)',
          fontVariantNumeric: 'tabular-nums',
        }}>
          {percentage}%
        </div>
        <div style={{ 
          fontSize: '14px', 
          color: 'var(--text-muted)',
          marginTop: 'var(--space-xs)',
        }}>
          Downloading encrypted file...
        </div>
      </div>

      {/* Progress bar */}
      <div className="progress" style={{ marginBottom: 'var(--space-md)' }}>
        <div 
          className="progress-bar" 
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Size info */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        fontSize: '13px',
        color: 'var(--text-muted)',
      }}>
        <span>{formatFileSize(downloadedBytes)}</span>
        <span>{formatFileSize(transfer.total_size)}</span>
      </div>
    </div>
  )
}
